export function initIndexedDB() {
    const request = indexedDB.open('LogsDB', 1);

    request.onupgradeneeded = function () {
        const db = request.result;
        if (!db.objectStoreNames.contains('logs')) {
            db.createObjectStore('logs', { autoIncrement: true });
        }
    };

    request.onerror = function (event) {
        console.log("[Error] al abrir IndexedDB:", event);
    };

    request.onsuccess = function () {
        console.log("[device] IndexedDB del dispositivo creada y lista.");
    };
}

// Función para guardar un log en IndexedDB
export function saveLogToIndexedDB(logText) {
    const request = indexedDB.open('LogsDB', 1);

    request.onsuccess = function () {
        const db = request.result;
        const transaction = db.transaction('logs', 'readwrite');
        const store = transaction.objectStore('logs');
        store.add({ log: logText, timestamp: new Date() });

        transaction.onerror = function () {
            console.log("[Error] al guardar en IndexedDB");
        };
    };
}

// Función para obtener los logs almacenados
export function getLogsFromIndexedDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('LogsDB', 1);

        request.onsuccess = function () {
            const db = request.result;
            const transaction = db.transaction('logs', 'readonly');
            const store = transaction.objectStore('logs');
            const logs = [];

            const cursorRequest = store.openCursor();
            cursorRequest.onsuccess = function (event) {
                const cursor = event.target.result;
                if (cursor) {
                    logs.push(cursor.value);
                    cursor.continue();
                } else {
                    resolve(logs);
                }
            };

            cursorRequest.onerror = function () {
                reject("[Error] al obtener los logs de IndexedDB");
            };
        };

        request.onerror = function () {
            reject("[Error] al abrir IndexedDB");
        };
    });
}

// Función para limpiar los logs de IndexedDB
export function clearLogsFromIndexedDB() {
    const request = indexedDB.open('LogsDB', 1);

    request.onsuccess = function () {
        const db = request.result;
        const transaction = db.transaction('logs', 'readwrite');
        const store = transaction.objectStore('logs');
        store.clear();

        transaction.onerror = function () {
            console.log("[Error] al borrar los logs de IndexedDB");
        };

        transaction.oncomplete = function () {
            console.log("[device] Logs eliminados de IndexedDB");
        };
    };

    request.onerror = function () {
        console.log("[Error] al abrir IndexedDB para borrar los logs");
    };
}

// Función para enviar los logs al servidor
export async function createLogFileAndSend(name = '', token = null) {
    try {
        const logs = await getLogsFromIndexedDB();
        console.log('[device] Logs obtenidos');

        if (!logs || logs.length === 0) {
           return false;
        }

        const logContent = logs.map(log => `${log.timestamp}: ${log.log}`).join("\n");

        if (logContent.trim() === "") {
            return false;
        }
        console.log('--------------------- ciclo de logs -------------------------');

        const response = await fetch('https://ap15.efisense.net/apiCRM/utilities/logs/upload', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                filename: name || 'logs.txt',
                content: logContent,
            }),
        });

        if (response.ok) {
            clearLogsFromIndexedDB();
        } else {
            const errorData = await response.json();
            console.error('[Error] al enviar los logs:', errorData.messages.error);
        }
    } catch (error) {
        console.log('[Error] al crear o enviar el archivo de logs:', error);
    }
}

// Sobrescribir console.log para guardar automáticamente en IndexedDB
const originalLog = console.log;
export function overrideConsoleLog() {
    console.log = function (...args) {
        try {
            const logText = args.map(arg => {
                try {
                    return typeof arg === "object" ? JSON.stringify(arg) : String(arg);
                } catch (e) {
                    return "[Error al serializar console.log]";
                }
            }).join(" ");

            saveLogToIndexedDB(logText);
            originalLog.apply(console, args);
        } catch (error) {
            originalLog("[Error] en console.log:", error);
        }
    };
}

// Ejecutar la inicialización al importar el módulo
initIndexedDB();
